package fr.manyverse.app.domain.usecase

import fr.manyverse.app.domain.model.AlertType
import fr.manyverse.app.domain.model.EventContent
import fr.manyverse.app.domain.model.EventType
import fr.manyverse.app.domain.repository.GameEventRepository

class SendGmAlertUseCase(private val gameEventRepository: GameEventRepository) {
    suspend operator fun invoke(
        tableId: String,
        gmId: String,
        message: String? = null
    ): Result<Unit> = gameEventRepository.createEvent(
        tableId = tableId,
        type = EventType.GM_ALERT,
        triggeredBy = gmId,
        targetParticipants = listOf(gmId),
        content = EventContent.PlayerAlert(
            characterName = "",
            alertType = AlertType.INAPPROPRIATE,
            message = message
        )
    ).map { }
}
